import React from "react";
import Modal from "../../components/Modal";
import i18n from "../../i18n";
import TouchEffect from "../../components/TouchEffect/TouchEffect";
import {logEvent, userEvents} from "../../utils/log";
import {ButtonStyled} from "./ResultPage.style";

export default class InstagramModal extends Modal {
  state = {
    username: "",
  }

  componentDidMount() {
    window.webviewEventsListeners.backPress.push(() => {
      this.dismiss();
      return true;
    });
  }

  dismiss(trigger) {
    window.webviewEventsListeners.backPress.pop();
    super.dismiss(trigger);
  }

  handleUsernameChange = (e) => {
    this.setState({
      username: e.target.value,
    });
  }

  handleDoneClick = () => {
    if (this.state.username.trim()) {
      logEvent(userEvents.INSTAGRAM_USERNAME, {
        username: this.state.username,
      });
    }

    this.dismiss();
  }

  renderModal() {
    return <React.Fragment>
      <button
        className="button-close-popup"
        onClick={this.dismiss}>
        <svg viewBox="0 0 16 16">
          <path strokeWidth=".5" d="M.554 2.025L6.53 8 .554 13.976c-.405.405-.405 1.064 0 1.47.406.405 1.065.405 1.47 0L8 9.47l5.975 5.975c.406.406 1.065.406 1.47 0h0c.406-.405.406-1.064 0-1.47L9.47 8l5.976-5.976h0c.405-.405.405-1.064 0-1.47-.406-.405-1.065-.405-1.47 0 0 0 0 0 0 0L8 6.53 2.024.554C1.62.15.96.15.554.554.15.96.148 1.62.554 2.024c0 0 0 0 0 0z" />
        </svg>
      </button>

      <h1 dangerouslySetInnerHTML={{__html: i18n.t("instagram_modal__title")}} />
      <p dangerouslySetInnerHTML={{__html: i18n.t("instagram_modal__text")}} />

      <label>@
        <input type="text" value={this.state.username} onChange={this.handleUsernameChange} />
      </label>

      <ButtonStyled full={1} disabled={!this.state.username} onClick={this.handleDoneClick}>
        {i18n.t("instagram_modal__done")}
        <TouchEffect />
      </ButtonStyled>
    </React.Fragment>;
  }
}